import { cn } from '../utils/cn'

export default function OqueE() {
  const mock = [
    {
      id: 1,
      title: 'Análise e diagnóstico personalizado',
      solutionTitle1: 'Entendimento profundo',
      solutionDescription1:
        'Iniciamos cada projeto com uma análise detalhada do ambiente atual, compreendendo as necessidades e objetivos específicos do cliente.',
      solutionTitle2: 'Avaliação de maturidade tecnológica',
      solutionDescription2:
        'Desenvolvemos uma avaliação da maturidade tecnológica existente para identificar pontos fortes e áreas de melhoria.',
      imgSrc: '../assets/o-que-e-1.png',
    },
    {
      id: 2,
      title: 'Design de arquitetura avançado',
      solutionTitle1: 'Abordagem personalizada',
      solutionDescription1:
        'Projetamos arquiteturas personalizadas que atendam aos requisitos funcionais e não funcionais, assegurando alinhamento com os objetivos estratégicos de negócio.',
      solutionTitle2: 'Uso de padrões de mercado',
      solutionDescription2:
        'Aplicamos padrões de mercado e melhores práticas para criar soluções escaláveis, modulares e sustentáveis.​',
      imgSrc: '../assets/o-que-e-2.png',
    },
    {
      id: 3,
      title: 'Implementação ágil e colaborativa',
      solutionTitle1: 'Metodologias ágeis',
      solutionDescription1:
        'Utilizamos metodologias ágeis para garantir entregas rápidas e interativas, realizando ajustes contínuos conforme necessário.',
      solutionTitle2: 'Colaboração Contínua',
      solutionDescription2:
        'Colaboramos estreitamente com as equipes internas do cliente, assegurando o alinhamento contínuo e a transferência de conhecimento.',
      imgSrc: '../assets/o-que-e-3.png',
    },
    {
      id: 4,
      title: 'Monitoramento e otimização constante',
      solutionTitle1: 'Ferramentas de Monitoramento',
      solutionDescription1:
        'Implementamos ferramentas de monitoramento avançadas para garantir a integridade e o desempenho contínuo das soluções.',
      solutionTitle2: 'Otimização Preditiva',
      solutionDescription2:
        'Garantimos que as soluções permaneçam eficientes e escaláveis através de otimizações contínuas baseadas em dados de desempenho.',
      imgSrc: '../assets/o-que-e-4.png',
    },
  ]

  return (
    <section className="bg-[url(../assets/cover-proposito.png)] text-white">
      <div className="container mx-auto xl:max-w-6xl px-4 pt-[200px] pb-[150px] space-y-[150px]">
        <article className="space-y-10 lg:space-y-0 lg:flex items-center justify-between gap-16">
          <h2 className="tracking-widest text-6xl w-full">O que é:</h2>
          <p className="text-2xl">
            Combinamos expertise técnica, métodos ágeis e foco em inovação para
            aprimorar a infraestrutura tecnológica dos seus negócios, garantindo
            desempenho, segurança e transformação contínua.
          </p>
        </article>

        <article className="flex flex-wrap gap-y-32">
          {mock.map((item, index) => (
            <div
              className="flex-wrap w-full gap-x-24 lg:flex space-y-6 lg:space-y-0"
              key={item.id}
            >
              <section
                className={`lg:w-[calc(50%-3rem)] ${index % 2 !== 0 ? 'order-2' : 'order-1'}`}
              >
                <img src={item.imgSrc} alt="" className="w-full" />
              </section>

              <section
                className={`lg:w-[calc(50%-3rem)] space-y-8 h-fit flex items-center ${index % 2 !== 0 ? 'order-1' : 'order-2'}`}
              >
                <div className="space-y-8">
                  <header className="space-y-5">
                    <p>
                      0{item.id}{' '}
                      <sup className="text-[#C9DDFE]">/0{mock.length}</sup>
                    </p>
                    <h2 className="text-5xl font-normal">{item.title}</h2>
                  </header>
                  <main className="border-l-4 border-[#2A2A2F] box-border ps-14 pt-3.5 space-y-7 relative ">
                    <div className="space-y-3.5">
                      <h3 className="text-2xl">{item.solutionTitle1}</h3>
                      <p className="text-[#9CA8BB]">
                        {item.solutionDescription1}
                      </p>
                    </div>
                    <div className="space-y-3.5">
                      <h3 className="text-2xl">{item.solutionTitle2}</h3>
                      <p className="text-[#9CA8BB]">
                        {item.solutionDescription2}
                      </p>
                    </div>
                    <div className="w-1 h-9 bg-[#A800E4] absolute -left-1 top-0 mt-4" />
                  </main>
                </div>
              </section>
            </div>
          ))}
        </article>
      </div>
    </section>
  )
}
